<template>
    <div class="row map-display">
        <div class="col-sm-12 map-col">
            <leaflet></leaflet>
        </div>
        <!-- <div class="col-sm-3 layer-title-container" style="overflow: scroll;">

            <li class="layer-title" v-for="(layer, position) in geoJsonLayers" >
                <input @click="setGeoJsonLayer(position, displayLayer(layer), layer, $event)"
                :key="position"
                :id="position" type="checkbox"/>{{ displayLayer(layer) }}
            </li>
        </div> -->
    </div>
</template>

<script>
    import Leaflet from './Leaflet';
    import store from '../../store';
    import $ from 'jquery';
    import { ReportWizard } from '../../api';
    export default {
        data () {
            return {
                selectedLayer: [],
                separatedLayers: []
            }
        },
        computed: {
            geoJsonLayers: function() {
                return store.state.geoJsonLayers;
            }
        },
        methods: {
            downloadXLS: async function () {
                let file = null;
                let geoJson = null;
                let label = null;
                for (var i = store.state.geoJsonObjects.length - 1; i >= 0; i--) {
                    file = store.state.geoJsonObjects[i];
                    geoJson = file['geo_json'];
                    label = file['label'].split('.')[0];
                    let _layer = {}
                    _layer[label] = this.separateGeoJsonLayers(geoJson);
                    this.separatedLayers.push(_layer);
                }
                let response = await ReportWizard.createAreaReport(this.separatedLayers);
                this.separatedLayers = [];
            },
            separateGeoJsonLayers(geoJson) {
              let layers = [
                {10: 'Cropland, rainfield'}, {11: 'Herbaceous Cover'},
                {12: 'Tree or shrub cover'}, {20: 'Cropland irrigated or post-flooding'},
                {30: 'Mosaic cropland (>50%) / natural vegetation (Tree, shrub, herbaceous cover) (<50%)'},
                {40: 'Mosaic natural vegetation'},
                {50: 'Tree cover, broadleaved, evergreen, closed to open (>15%)'},
                {60: 'Tree cover, broadleaved, deciduous, closed to open (>15%)'},
                {61: 'Tree cover, broadleaved, deciduous, closed (>40%)'},
                {62: 'Tree cover, broadleaved, deciduous, open (15-40%)'},
                {70: 'Tree cover, needleleaved, evergreen, closed to open (>15%)'},
                {71: 'Tree cover, needleleaved, evergreen, closed (>40%)'},
                {72: 'Tree cover, needleleaved, evergreen, open (15-40%)'},
                {80: 'Tree cover, needleleaved, deciduous, closed to open (>15%)'},
                {81: 'Tree cover, needleleaved, deciduous, closed (>40%)'},
                {82: 'Tree cover, needleleaved, deciduous, open (15-40%)'},
                {90: 'Tree cover, mixed leaf type (broadleaved and needleleaved)'},
                {100: 'Mosaic T and shrub (>50%) / herbaceous cover (<50%)'},
                {110: 'Mosaic herbaceous cover (>50%) / T and shrub (<50%)'},
                {120: 'Shrubland'}, {121: 'Shrubland evergreen'},
                {122: 'Shrubland deciduous'}, {130: 'Grassland'},
                {140: 'Lichens and mosses'}, {150: 'Sparse vegetation (tree, shrub, herbaceous cover) (<15%)'},
                {151: 'Sparse tree (<15%)'}, {152: 'Sparse shrub (<15%)'},
                {153: 'Sparse herbaceous cover (<15%)'}, {160: 'Tree cover, flooded, fresh or brakish water'},
                {170: 'Tree cover, flooded, saline water'},
                {180: 'Shrub or herbaceous cover, flooded, fresh/saline/brakish water'}, {190: 'Urban areas'},
                {200: 'Bare areas'}, {201: 'Consolidated bare areas'}, {202: 'Unconsolidated bare areas'},
                {220: 'Permanent snow and ice'}
              ]
              let finalLayers = [];
              let colors = {
                'Cropland, rainfield':'#2383c4',
                'Herbaceous Cover': '#aaff23',
                'Tree cover, broadleaved, evergreen, closed to open (>15%)': '#249151',
                'Urban areas': '#ff0031',
                'Mosaic natural vegetation': '#00ff50'
              }
              let _layers = [];
              let geoJsonLayers = {}
              for (let layer of layers) {
                let key = Object.keys(layer)[0]
                _layers = geoJson.features.filter(function(feature){
                  return feature.properties.GRIDCODE === Number(key);
                })
                if (_layers.length === 0) {
                  continue;
                } else {
                  geoJsonLayers[layer[key]] = _layers;
                }
              }
              for (var key in geoJsonLayers) {
                if (geoJsonLayers.hasOwnProperty(key)) {
                  let obj = {};
                  let layerColor = null
                  if (colors[key] !== undefined) {
                    console.log('foun color for ', key);
                    layerColor = colors[key];
                  }else{
                    console.log('did not find color for ', key);
                    layerColor = '#713093';
                  }
                  let geoJSONFormat = {
                    "type": "FeatureCollection",
                    "features": [
                    ],
                    "color": layerColor
                  };
                  let parsedLayers = geoJsonLayers[key];
                  geoJSONFormat.features.push.apply(geoJSONFormat.features, parsedLayers);
                  obj[key] = geoJSONFormat;
                  finalLayers.push(obj)
                }
              }
              return finalLayers;
            },
            displayLayer: function (layer) {
                return Object.keys(layer)[0];
            },
            setGeoJsonLayer: function (position, layerName, layer, event) {
                let isNotChecked = $(`#${position}`).prop('checked');
                if (isNotChecked){
                    let key = Object.keys(layer)[0];
                    let obj = layer[key];
                    let _temp = obj.features[0];
                    store.dispatch('setActiveLayer', position + '-' + layerName);
                    let gridCode = _temp.properties.GRIDCODE;
                    store.dispatch('setActiveLayer', position + '-' + layerName);
                }else{
                    store.dispatch('removeLayer', layer)
                }

            }
        },
        components: {
            Leaflet
        }
    }

</script>

<style scoped>
.map-display{
    height: 100%;

}
.col-sm-9 {
    padding-left: 0px;
    padding-right:0px;
}
.layer-title-container{
    height: 100vh;
    background: white;
    padding-left:10px;
}
.layer-title {
    margin-top: 2px;
    border-bottom: 1px solid #F0F0F0;
    padding-bottom: 5px;
    background: white;
    list-style-type: none;
    cursor: pointer;
    text-transform: capitalize;
}
.map-col{
    height: 60vh;
    padding-right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/report/MapDisplay.vue